module.exports = __webpack_public_path__ + "img/软件产品证书-自动语音警告系统V1.0.2b7b712b.jpg";